// Initialize global lio object
window.lio = window.lio ?? {};

export {};
